module.exports = __webpack_public_path__ + "static/sergiler3-8ea1d39830de759a44958df817834f6a.png";